export const onHeaderActionClick = (
  key: string,
  quoteId: string,
  createProjectFromQuote: () => void,
  downloadQuotePdf: (quoteId: string) => void,
  deleteQuote: () => void,
  openPreview: () => void,
  navigateToProject: () => void,
  navigateToInvoice: () => void,
  convertToInvoice: () => void
) => {
  switch (key) {
    case 'convert_to_project':
      return createProjectFromQuote()
    case 'go_to_project':
      return navigateToProject()
    case 'convert_to_invoice':
      return convertToInvoice()
    case 'go_to_invoice':
      return navigateToInvoice()
    case 'download_quote':
      return downloadQuotePdf(quoteId)
    case 'delete_quote':
      return deleteQuote()
    case 'open_preview':
      return openPreview()
  }
}
